import styled from 'styled-components';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';
import { Wrapper } from '~/src/components/Videocontrol/questions/styled';

export const Bonus = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 0;
  @media (min-width: 300px) {
    flex-direction: column-reverse;
    justify-content: space-between;
    align-items: start;
  }
  @media (min-width: 1180px) {
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
  }
`;

export const WrapperText = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: 1280px) {
    padding-left: 0;
    width: 450px;
    margin-bottom: 56px;
  }
  @media (min-width: 1180px) {
    padding-left: 10px;
    width: 350px;
    margin-bottom: 56px;
  }
`;

export const WrapperMobileBtn = styled.div`
    display: flex;
    justify-content: space-between;
    width: 305px;
`;

export const Picture = styled.picture`
    display: flex;
    margin-top: ${p => p.marginTop ? p.marginTop : '35px'};
    align-self: center;    
    max-width: ${p => p.maxWidth ? p.maxWidth : '450px'};
    @media(max-width: 1600px) {
        max-width: ${p => p.maxWidth ? p.maxWidth : '383px'};
    }
    @media(max-width: 1440px) {
        margin-top: ${p => p.marginTop ? p.marginTop : '75px'};
        max-width: ${p => p.maxWidth ? p.maxWidth : '320px'};
    }
    @media(max-width: 1280px) {
        max-width: ${p => p.maxWidth ? '115px' : '320px'};
        width: ${p => p.maxWidth ? '80%' : 'auto'};
    }
    @media(max-width: 1024px) {
        align-self: start; 
        max-width: ${p => p.maxWidth ? p.maxWidth : '450px'};
    }
    @media(max-width: 390px) {
        width: 100%
    }
`;

export const Img = styled.img`
    max-width: 450px;
    @media(max-width: 1600px) {
        max-width: ${p => p.maxWidth ? p.maxWidth : '383px'};
    }
    @media(max-width: 1440px) {
        max-width: ${p => p.maxWidth ? p.maxWidth : '320px'};
    }
    @media(max-width: 1280px) {
        max-width: ${p => p.maxWidth ? p.maxWidth : '320px'};
        width: ${p => p.maxWidth ? '80%' : '100%'};
    }
    @media(max-width: 1024px) {
        max-width: ${p => p.maxWidth ? p.maxWidth : '450px'};
    }
    @media(max-width: 390px) {
        width: calc(100% - 20px);
        height: 100%;
    }
`;

export const Source = styled.source`
    @media(max-width: 390px) {
        width: calc(100% - 20px);
        height: 100%;
    }
`;

export const Title = styled.h2`
    margin-top: 50px;
    margin-bottom: 25px;
    font-size: 32px;
    line-height: 1.33;
    font-family: ${FONTS.regular};
    color: ${COLORS.white};
    @media(max-width: 1280px) {
        margin-top: 40px;
        margin-bottom: 15px;
    }
`;

export const PaddingWrapper = styled(Wrapper)`
    padding-top: ${p => p.nonTopPadding ? '0' : '120px'};
    padding-bottom: ${p => p.nonBottomPadding ? '0' : '120px'};
    @media(max-width: 1240px) {
        padding-top: 24px;
    }
`;
